/* eslint-disable key-spacing */
/* eslint-disable no-nested-ternary */

/* eslint-disable no-promise-executor-return */
import React, { useEffect, useRef, useState } from "react";
import { Button, Input, Row, Spin, Image, Modal, message } from "antd";
import styled from "styled-components";
import { datetimeFormat, yen } from "../../../utils";
import {
  SendOutlined,
  FileAddFilled,
  DownloadOutlined,
  FileOutlined,
  CloseCircleOutlined,
  LoadingOutlined,
  FileImageOutlined,
  FilePdfOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import ImagePreviewModal from "../../../components/ImagePreviewModal";
import { MyTable } from "../../../components";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { useParams } from "react-router-dom";
import { socket } from "../../../components/SocketClient";
import { message as messageApi } from "../../../apis";
import dayjs from "dayjs";
import { useTranslate } from "../../../hooks";
import { upload } from "../../../apis/message";
import { quickMessage as quickMessageApi } from "../../../apis";
import { Modal as AntModal } from "antd";
import { MessageOutlined } from "@ant-design/icons";
import Print from "./Print";
import utc from "dayjs/plugin/utc";
import { PhotoIcon } from "@heroicons/react/24/solid";
dayjs.extend(utc);

const isImageUrl = (url = "") =>
  /\.(jpg|jpeg|png|gif|webp|bmp|svg)(\?.*)?$/i.test(url);
const isPdfUrl = (url = "") => /\.pdf(\?.*)?$/i.test(url);
const DRAFT_KEY = "chat_draft";

const Chat = ({ data }) => {
  const auth = useSelector((state) => state.auth);
  const { user } = useSelector((state) => state.general);
  const dispatch = useDispatch();
  const { translate } = useTranslate();
  const { chats, scrollOn, reload } = useSelector((state) => state.socket);
  const [value, setValue] = React.useState("");
  const [file, setFile] = React.useState(null);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [chatLength, setChatLength] = useState(0);
  const viewport = useRef();
  const [fileLoading, setFileLoading] = React.useState(false);
  const [preview, setPreview] = useState({ open: false, src: null });
  const [print, setPrint] = useState([false]);
  const quickMessageTableRef = React.useRef();
  const debounceRef = React.useRef();
  const [qmQuery, setQmQuery] = useState("");
  const [qmFilters, setQmFilters] = useState({ query: "", });
  const [qmModalOpen, setQmModalOpen] = useState(false);
  const [filters, setFilters] = useState({
    offset: {
      page: 1,
      limit: 10,
    },
    filter: {
      id: params?.id,
    },
  });

  React.useEffect(() => {
    const savedDraft = localStorage.getItem(DRAFT_KEY + params.id);
    if (savedDraft) {
      setValue(savedDraft);
    }
  }, []);

  React.useEffect(() => {
    const handler = setTimeout(() => {
      if (value) {
        localStorage.setItem(DRAFT_KEY + params.id, value);
      } else {
        localStorage.removeItem(DRAFT_KEY + params.id);
      }
    }, 300);
    return () => clearTimeout(handler);
  }, [value]);

  const send = async () => {
    try {
      if (file) {
        setValue("");
        if (value?.trim()?.length > 0) {
          await messageApi.send({
            uid: uuidv4(),
            user: user?._id,
            message: value,
            url: undefined,
            conversationId: params.id,
          });
          // await socket.emit("action", {
          //   type: "conversation.chat",
          //   payload: {
          //     uid: uuidv4(),
          //     user: user?._id,
          //     message: value,
          //     url: undefined,
          //     conversationId: params.id,
          //   },
          // });
        }
        await messageApi.send({
          uid: uuidv4(),
          user: user?._id,
          message: file[0],
          url: file[1],
          conversationId: params.id,
        });

        // await socket.emit("action", {
        //   type: "conversation.chat",
        //   payload: {
        //     uid: uuidv4(),
        //     user: user?._id,
        //     message: file[0],
        //     url: file[1],
        //     conversationId: params.id,
        //   },
        // });

        setFile(null);
      } else if (value?.trim()?.length > 0) {
        setValue("");
        const CHAT = {
          uid: uuidv4(),
          user: user?._id,
          message: value,
          url: undefined,
        };
        await messageApi.send({
          ...CHAT,
          conversationId: params.id,
        });
        localStorage.removeItem(DRAFT_KEY + params.id);
        // await socket.emit("action", {
        //   type: "conversation.chat",
        //   payload: {
        //     ...CHAT,
        //     conversationId: params.id,
        //   },
        // });
      }
    } catch (err) {
      console.log("------>err", err);
      message.error("メッセージ送信失敗しました！");
    }
  };

  const onUploadFile = async (e) => {
    setFileLoading(true);
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await fetch("/api/conversation/upload", {
        body: formData,
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        contentType: "multipart/form-data",
        method: "POST",
      });
      const data = await res.json();
      setFile([file?.name, data?.url]);
      setFileLoading(false);
    } catch (error) {
      console.log("File upload error");
      setFileLoading(false);
    }
  };

  const scrollToBottom = (smooth) =>
    viewport?.current?.scrollTo({
      top: viewport?.current.scrollHeight,
      behavior: smooth ? "smooth" : "auto",
    });

  const reloadChatInit = async () => {
    dispatch({
      type: "socket.clear",
    });
    if (params.id)
      await socket?.emit("action", {
        type: "owner.seen",
        payload: params.id,
      });
  };

  const loaData = async () => {
    setLoading(true);
    if (filters.filter.id) {
      setTimeout(async () => {
        const res = await messageApi.chat(filters);

        dispatch({
          type: "socket.chats",
          payload: [...chats, ...res.rows],
        });
        dispatch({
          type: "socket.chat.reload",
          payload: null,
        });
        setChatLength(res?.count || 0);
        setLoading(false);
        if (filters.offset.page === 1) {
          setTimeout(() => scrollToBottom(false), 50);
        } else {
          await viewport?.current?.scrollTo({ top: 20, behavior: "smooth" });
        }
      }, 1000);
    }
  };

  const delay = (delayInms) => {
    return new Promise((resolve) => setTimeout(resolve, delayInms));
  };

  const onScroll = async (e) => {
    if (e) {
      const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
      if (chats.length < chatLength) {
        if (scrollTop === 0) {
          setLoading(true);
          await delay(30);
          setLoading(false);
          setFilters({
            ...filters,
            offset: { ...filters.offset, page: filters.offset.page + 1 },
          });
        }
      }
    }
  };

  useEffect(() => {
    loaData();
  }, [filters]);

  useEffect(() => {
    if (scrollOn) scrollToBottom();
    dispatch({
      type: "scroll.off",
    });
  }, [scrollOn]);

  useEffect(() => {
    reloadChatInit();
  }, []);

  useEffect(() => {
    if (reload === params.id) {
      dispatch({ type: "socket.chats", payload: [] });
      setFilters({
        ...filters,
        offset: {
          page: 1,
          limit: 10,
        },
      });
      loaData();
    }
  }, [reload]);

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      setQmFilters({
        query: qmQuery,
        isActive: true,
      });
    }, 300);
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [qmQuery]);

  const paymentStatus = (status) => {
    if (status === "PENDING" || status === "TRANSFER")
      return (
        <div
          style={{
            padding: 4,
            textAlign: "center",
            backgroundColor: "#2196f3",
            color: "white",
            borderRadius: 5,
          }}
        >
          {translate(status, status)}
        </div>
      );
    if (status === "PAID")
      return (
        <div
          style={{
            padding: 4,
            textAlign: "center",
            backgroundColor: "#4caf50",
            color: "white",
            borderRadius: 5,
          }}
        >
          {translate(status, status)}
        </div>
      );
    if (status === "CANCELLED")
      return (
        <div
          style={{
            padding: 4,
            textAlign: "center",
            backgroundColor: "#f44336",
            color: "white",
            borderRadius: 5,
          }}
        >
          {translate(status, status)}
        </div>
      );
  };
  const Payment = ({ item }) => {
    return (
      <PaymentStyled>
        <div className="container">
          <table>
            <tr>
              <td>
                <div>{translate("chat.amount", "Amount")}:</div>
              </td>
              <td>
                <div>{yen(item?.payment?.amount)}</div>
              </td>
            </tr>
            <tr>
              <td>
                <div>{translate("chat.tax", "Tax")}:</div>
              </td>
              <td>
                <div>{yen(item?.payment?.tax)}</div>
              </td>
            </tr>
            <tr>
              <td>
                <div>{translate("chat.total.amount", "Total amount")}:</div>
              </td>
              <td>
                <div>{yen(item.payment.tax + item.payment.amount || 0)}</div>
              </td>
            </tr>
            <tr>
              <td>
                <div>{translate("chat.total.duration", "Duration")}:</div>
              </td>
              <td>
                <div>
                  {dayjs(item?.payment?.startDate).format("YYYY/MM/DD")}-
                  {dayjs(item?.payment?.endDate).format("YYYY/MM/DD")}
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div>
                  {translate("app.chat.chat.expireDate", "Payment expire date")}
                  :
                </div>
              </td>
              <td>
                <div className="text-[13px] max-w-md break-words text-end">
                  {dayjs.utc(item?.payment?.expireDate).format("YYYY/MM/DD")}
                </div>
              </td>
            </tr>
          </table>
          <div>
            {translate("chat.payment.alert.pay", "Pay the before tommorow!")}
          </div>
          {item.payment.paymentStatus !== "CANCELLED" && (
            <div
              style={{
                display: "flex",
                gap: 8,
                padding: 10,
              }}
            >
              <Button
                onClick={() => {
                  if (item.payment.pdfUrl) {
                    window.open(item.payment.pdfUrl, "_blank");
                  } else {
                    setPrint([true, item]);
                  }
                }}
                type="primary"
                style={{ flex: 1 }}
              >
                {translate("app.chat.chat.estimation", "See estimation")}
              </Button>
              {item.payment.invoiceUrl && (
                <Button
                  type="primary"
                  onClick={() => window.open(item.payment.invoiceUrl, "_blank")}
                  style={{ flex: 1 }}
                >
                  {translate("app.chat.chat.invoice", "御請求書")}
                </Button>
              )}
              {item.payment.receiptUrl && (
                <Button
                  type="primary"
                  onClick={() => window.open(item.payment.receiptUrl, "_blank")}
                  style={{ flex: 1 }}
                >
                  {translate("app.chat.chat.receipt", "領収書")}
                </Button>
              )}
            </div>
          )}

          <div style={{ padding: 10 }}>
            {paymentStatus(item?.payment?.paymentStatus)}
          </div>
        </div>
        <div className="chat-date">
          {dayjs(item.chatSendDate).format("YYYY/MM/DD HH:mm")}
        </div>
        <PrintModal
          centered
          title={translate("chat.payment.print", "Print")}
          onCancel={() => setPrint([false])}
          visible={print[0]}
          footer={false}
        >
          <Print data={print[1] || null} />
        </PrintModal>
      </PaymentStyled>
    );
  };

  const Order = ({ item }) => {
    return (
      <OrderStyled>
        <div className="container">
          <div className="title">
            {translate("chat.about.planning", "About planning")}
          </div>
          <div className="value">{item?.order.useType}</div>
          <div className="label">
            {translate("chat.project.name", "Project name")}
          </div>
          <div>{item?.order.businessName}</div>
          <div className="label">
            {translate("app.chat.chat.homepage", "ホームぺージURL")}
          </div>
          <a
            href={item?.order?.homepage}
            download
            style={{
              color: "#146cbeff", // blue
              textDecoration: "underline",
              display: "inline-flex",
              alignItems: "center",
              gap: "4px", // spacing between icon and text
              cursor: "pointer",
              maxWidth: "200px", // adjust as needed
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
            title={item?.order?.homepage} // hover shows description
          >
            {item?.order?.homepage} {/* Visible title */}
          </a>
          <div className="label">
            {translate("chat.plan.contents", "Plan contents")}
          </div>
          <div style={{ whiteSpace: "pre-wrap" }}>
            {item?.order.businessDesc}
          </div>
          <div className="label">
            {translate(
              "chat.eating.and.drinking.tasting",
              "Eating and drinking / tasting",
            )}
          </div>
          <div>
            {item?.order.isProvisional
              ? translate("app.chat.detail.provided", "Provided")
              : translate("app.chat.detail.no", "No")}
          </div>
          <div className="label">{translate("app.chat.chat.payment", "決済方法")}</div>
          <div>
            <label style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <input
                type="checkbox"
                readOnly
                checked={!!item?.order?.payByCard}
                style={{ accentColor: "rgb(255, 125, 38)", width: 18, height: 18, pointerEvents: "none" }}
              />
              {translate("app.bulk.step1.payment.card", "クレジットカード払い")}
            </label>
            <label style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <input
                type="checkbox"
                readOnly
                checked={!!item?.order?.payByTransfer}
                style={{ accentColor: "rgb(255, 125, 38)", width: 18, height: 18, pointerEvents: "none" }}
              />
              {translate("app.bulk.step1.payment.transfer", "お振込み")}
            </label>
          </div>
          <div className="label">{translate("chat.inquiry", "Inquiry")}</div>
          <div style={{ whiteSpace: "pre-wrap" }}>{item?.order.inquiry}</div>
          {Array.isArray(item?.order?.files) ? (
            <div>
              <div className="label">
                {translate("app.chat.chat.files", "企画に関する資料")}
              </div>
              {item?.order?.files.map((file) => {
                const url = file?.url || "";
                const image = isImageUrl(url);
                const pdf = isPdfUrl(url);
                const Icon = image
                  ? FileImageOutlined
                  : pdf
                    ? FilePdfOutlined
                    : FileOutlined;
                return (
                  <a
                    key={url}
                    href={url}
                    // pdf opens in a new tab (browser default viewer),
                    // image opens the preview popup, everything else downloads
                    {...(pdf
                      ? { target: "_blank", rel: "noopener noreferrer" }
                      : image
                        ? {
                          onClick: (e) => {
                            e.preventDefault();
                            setPreview({ open: true, src: url });
                          },
                        }
                        : { download: true })}
                    title={file.description}
                    style={{
                      color: "#146cbeff",
                      textDecoration: "underline",
                      display: "flex", // full-width flex
                      alignItems: "center",
                      gap: "4px",
                      cursor: "pointer",
                      maxWidth: "100%", // take full parent width
                    }}
                  >
                    <Icon size={18} />
                    <span
                      style={{
                        flex: 1, // take remaining space
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {file.description}
                    </span>
                  </a>
                );
              })}
              <ImagePreviewModal
                open={preview.open}
                src={preview.src}
                onClose={() => setPreview({ open: false, src: null })}
              />
            </div>
          ) : null}
        </div>
        <div className="chat-date">
          {dayjs(item.chatSendDate).format("YYYY/MM/DD HH:mm")}
        </div>
      </OrderStyled>
    );
  };

  const uniqueChats = chats.reduce((accumulator, item) => {
    const foundItem = accumulator?.find(
      (existingItem) => existingItem._id === item._id,
    );
    if (!foundItem) {
      accumulator.push(item);
    }
    return accumulator;
  }, []);

  if (loading) {
    return (
      <Row justify="center">
        <Spin />
      </Row>
    );
  }
  const quickMessageColumns = [
    {
      title: "タイトル",
      render: (record) => record.title,
    },
    {
      title: "",
      width: 100,
      render: (record) => (
        <Button
          type="primary"
          size="small"
          onClick={() => {
            setValue((prev) =>
              prev ? `${prev}\n${record.description}` : record.description
            );
            setQmModalOpen(false);
          }}
        >
          選択
        </Button>
      ),
    },
  ];
  return (
    <Container>
      <ScrollStyled file={file} ref={viewport} onScroll={onScroll}>
        {uniqueChats
          ?.slice(0)
          .reverse()
          ?.map((item, index) => {
            if (item?.order) {
              return (
                <ChatRow
                  key={index}
                  className={item.user === data?.tenant?._id ? "" : "right"}
                >
                  <Order item={item} />
                </ChatRow>
              );
            }
            if (item?.url) {
              const isImage = isImageUrl(item.url);
              if (isImage) {
                return (
                  <div key={index}>
                    <ChatImageRow
                      className={item.user === data?.tenant?._id ? "" : "right"}
                    >
                      <div className="chat-wrapper">
                        {isImage ? (
                          <>
                            <img
                              src={item.url}
                              alt={item.message || "image"}
                              className="chat-image"
                              onClick={() => setPreview({ open: true, src: item.url })}
                            />
                            <div className="chat-date">
                              {datetimeFormat(item?.chatSendDate)}
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="chat-message file-message">
                              <FileOutlined style={{ fontSize: 32 }} />
                              <div className="file-name">{item?.message}</div>
                              <a onClick={() => window.open(item?.url)}>
                                <DownloadOutlined style={{ fontSize: 24 }} />
                              </a>
                            </div>
                            <div className="chat-date">
                              {datetimeFormat(item?.chatSendDate)}
                            </div>
                          </>
                        )}
                      </div>
                    </ChatImageRow>
                    <ImagePreviewModal
                      open={preview.open}
                      src={preview.src}
                      onClose={() => setPreview({ open: false, src: null })}
                    />
                  </div>
                );
              }
              return (
                <div key={index}>
                  {item?.url && (
                    <ChatRow
                      className={item.user === data?.tenant?._id ? "" : "right"}
                    >
                      <div>
                        <div>
                          <div
                            style={{
                              borderRadius: "5px",
                              backgroundColor: "#f3f4f6",
                              padding: "10px 14px",
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <div style={{ fontSize: "32px" }}>
                              <FileOutlined />
                            </div>
                            <div style={{}} className="">
                              {item?.message}
                            </div>
                            <a
                              onClick={() => window.open(item?.url)}
                              style={{ fontSize: "24px" }}
                            >
                              <DownloadOutlined />
                            </a>
                          </div>
                          <div className="chat-date">
                            {datetimeFormat(item?.chatSendDate)}
                          </div>
                        </div>
                      </div>
                    </ChatRow>
                  )}
                </div>
              );
            }
            if (item?.payment) {
              return (
                <ChatRow
                  className={item.user === data?.tenant?._id ? "" : "right"}
                  key={index}
                >
                  <Payment item={item} />
                </ChatRow>
              );
            }

            return (
              <div key={index}>
                {item?.message && (
                  <ChatRow
                    className={item.user === data?.tenant?._id ? "" : "right"}
                  >
                    <div>
                      <div className="chat-wrapper">
                        <div className="chat-message">{item?.message}</div>
                        <div className="chat-date">
                          {/* {datetimeFormat(item?.chatSendDate)} */}
                          {datetimeFormat(item?.chatSendDate)}
                        </div>
                      </div>
                    </div>
                  </ChatRow>
                )}
              </div>
            );
          })}
      </ScrollStyled>

      <SendStyled>
        {file ? (
          <div className="file">
            <div className="fileBox">
              <a onClick={() => setFile(null)} className="x">
                <CloseCircleOutlined />
              </a>
              <Image preview={false} className="img" src={"/file.svg"} />
              <div className="text">{file[0]}</div>
            </div>
          </div>
        ) : null}
        <div className="inputContainer">
          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            {fileLoading ? (
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  width: "59px",
                  height: "30px",
                  color: "white",
                  borderRadius: "3px",
                  backgroundColor: "#e05c04",
                  padding: "2px",
                }}
              >
                <Spin
                  style={{
                    marginLeft: "20%",
                    position: "absolute",
                    font: "24px",
                  }}
                  indicator={
                    <LoadingOutlined
                      style={{
                        fontSize: 24,
                        color: "white",
                      }}
                      spin
                    />
                  }
                />
              </div>
            ) : (
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  width: "50px",
                  height: "30px",
                  color: "white",
                  borderRadius: "3px",
                  backgroundColor: "#e05c04",
                  padding: "2px",
                }}
              >
                <input
                  type="file"
                  onChange={onUploadFile}
                  style={{
                    width: "50px",
                    opacity: 0,
                    zIndex: 1,
                  }}
                />

                <FileAddFilled
                  style={{
                    fontSize: "24px",
                    marginLeft: "25%",
                    position: "absolute",
                  }}
                />
              </div>
            )}
            <Button
              icon={<MessageOutlined />}
              onClick={() => setQmModalOpen(true)}
              style={{ width: "50px", height: "30px", padding: 0, backgroundColor: "#1890ff", color: "white", border: "none" }}
            />
          </div>
          <Input.TextArea
            rows={10}
            value={value}
            placeholder="..."
            onChange={(e) => {
              setValue(e.target.value);
            }}
          />
          <Button
            type="primary"
            onClick={() => {
              send();
            }}
          >
            {translate("chat.btn.send", "Send")} <SendOutlined />
          </Button>
        </div>
      </SendStyled>
      <AntModal
        title="クイックメッセージ"
        open={qmModalOpen}
        onCancel={() => setQmModalOpen(false)}
        footer={null}
        width={1000}
      >
        <div style={{ marginBottom: 16 }}>
          <Input.Search
            placeholder="タイトル検索..."
            prefix={<SearchOutlined/>}
            value={qmQuery}
            onChange={(e) => setQmQuery(e.target.value)}
          />
        </div>
        <MyTable
          ref={quickMessageTableRef}
          rowKey={(record) => record._id}
          columns={quickMessageColumns}
          filters={qmFilters}
          loadData={quickMessageApi.list}
          scroll={{ y: 500 }}
        />
      </AntModal>
    </Container>
  );
};

const Container = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const ScrollStyled = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 10px 16px;
`;

const SendStyled = styled.div`
  display: flex;
  width: 100%;
  border-top: 1px solid #f3f4f6;
  gap: 8px;
  flex-direction: column;
  padding: 12px;
  background-color: white;
  flex-shrink: 0;

  .file {
    .fileBox {
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 3px;
      padding: 5px;
      border: 1px solid #c4c3c2;
      border-radius: 3px;
      background-color: #fcfbfa;
      width: 100px;
      height: 120px;

      .x {
        cursor: pointer;
        color: gray;
        font-size: 20px;
        position: absolute;
        top: 0;
        margin-top: -14px;
        margin-right: -10px;
        height: 24px;
        background-color: white;
        border-radius: 100%;
        right: 0;
        :hover {
          color: red;
        }
      }

      .img {
        height: 50px;
      }
      .text {
        overflow: hidden;
        line-clamp: 2;
        word-break: break-all;
      }
    }
  }
  .inputContainer {
    display: flex;
    width: 100%;
    gap: 8px;
  }
`;

const OrderStyled = styled.div`
  margin-top: 10px;
  width: 100%;
  max-width: 450px;

  .container {
    border: 1px solid #dadada;
    max-width: 450px;
    background-color: white;
    padding: 10px;
    border-radius: 5px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;

    .label {
      font-size: 18px;
      font-weight: 500;
    }
    .title {
      font-size: 18px;
      font-weight: 500;
      color: #333;
    }
  }
`;

const PrintModal = styled(Modal)`
  .ant-modal-content {
    width: 620px;
  }

  @media print {
    .ant-modal {
      width: 100vh;
      height: 100vh;
      background-color: white;
    }

    .ant-modal-header {
      display: none;
    }
    .ant-modal-close-x {
      display: none;
    }

    .ant-modal-mask {
      display: none !important;
    }
    .ant-modal-body {
      position: relative;
      width: 100%;
      height: 90%;
    }
    .ant-modal-content {
      position: fixed;
      left: 0;
      top: 0;
      box-shadow: none;
      height: 100%;
      width: 100%;
    }
  }
`;

const PaymentStyled = styled.div`
  margin-top: 10px;
  width: 100%;
  max-width: 450px;

  .container {
    max-width: 450px;
    background-color: white;
    border: 1px solid #dadada;
    padding: 0 10px;
    border-radius: 5px;
    width: 100%;
  }

  table {
    width: 100%;
    font-weight: 600;

    tr {
      border-bottom: 1px solid #dadada;
      div {
        padding: 8px 0;
      }

      td:last-child {
        text-align: end;
      }
    }

    tr:last-child {
      border: 0;
    }
  }
`;

const ChatRow = styled.div`
  width: 100%;
  display: flex;
  padding: 5px 14px;

  .chat-wrapper {
    max-width: 500px;

    .chat-message {
      background: #f3f4f6;
      border-radius: 5px;
      padding: 10px 14px;
      word-wrap: break-word;
      word-break: break-all;
      white-space: pre-wrap;
    }
  }
  .chat-date {
    font-size: 13px;
    color: #9ca3af;
    line-height: 22px;
  }

  &.right {
    justify-content: end;
    .chat-date {
      text-align: end;
    }

    .chat-message {
      background: #f66d3b;
      color: #fff;
    }
  }
`;
const ChatImageRow = styled.div`
  width: 100%;
  display: flex;
  padding: 5px 14px;

  .chat-wrapper {
    max-width: 500px;
  }

  .chat-message {
    background: #f3f4f6;
    border-radius: 5px;
    padding: 10px 14px;
    display: flex;
    align-items: center;
    gap: 8px;
    word-break: break-all;
  }

  .chat-image {
    max-width: 300px;
    max-height: 300px;
    border-radius: 8px;
    cursor: pointer;
    object-fit: cover;
  }

  .chat-date {
    font-size: 13px;
    color: #9ca3af;
    line-height: 22px;
  }

  &.right {
    justify-content: flex-end;

    .chat-date {
      text-align: right;
    }
  }
`;

export default Chat;